/* eslint-disable */
import MissionIcon from './MissionIcon.png';
import OpportunitiesIcon from './OpportunitiesIcon.png';
import StrengthsIcon from './StrengthsIcon.png';
import ThreatsIcon from './ThreatsIcon.png';
import twitter from './twitter.png';
import ValuesIcon from './ValuesIcon.png';
import VisionIcon from './VisionIcon.png';
import WeaknessesIcon from './WeaknessesIcon.png';

export { MissionIcon, OpportunitiesIcon, StrengthsIcon, ThreatsIcon, twitter, ValuesIcon, VisionIcon, WeaknessesIcon };

import AddressOfRegistrationIconGreen from './green/AddressOfRegistrationIcon.png';
import AddressOfRegistrationIconBlue from './blue/AddressOfRegistrationIcon.png';
import AddressOfRegistrationIconRed from './red/AddressOfRegistrationIcon.png';
import AddressOfRegistrationIconBlueGreen from './blueGreen/AddressOfRegistrationIcon.png';
import AddressOfRegistrationIconBlueRed from './blueRed/AddressOfRegistrationIcon.png';
import AddressOfRegistrationIconBlueYellow from './blueYellow/AddressOfRegistrationIcon.png';

import AddressTableIconGreen from './green/AddressTableIcon.png';
import AddressTableIconBlue from './blue/AddressTableIcon.png';
import AddressTableIconRed from './red/AddressTableIcon.png';
import AddressTableIconBlueGreen from './blueGreen/AddressTableIcon.png';
import AddressTableIconBlueRed from './blueRed/AddressTableIcon.png';
import AddressTableIconBlueYellow from './blueYellow/AddressTableIcon.png';

import AdressSixIconGreen from './green/AdressSixIcon.png';
import AdressSixIconBlue from './blue/AdressSixIcon.png';
import AdressSixIconRed from './red/AdressSixIcon.png';
import AdressSixIconBlueGreen from './blueGreen/AdressSixIcon.png';
import AdressSixIconBlueRed from './blueRed/AdressSixIcon.png';
import AdressSixIconBlueYellow from './blueYellow/AdressSixIcon.png';

import AgeIconGreen from './green/AgeIcon.png';
import AgeIconBlue from './blue/AgeIcon.png';
import AgeIconRed from './red/AgeIcon.png';
import AgeIconBlueGreen from './blueGreen/AgeIcon.png';
import AgeIconBlueRed from './blueRed/AgeIcon.png';
import AgeIconBlueYellow from './blueYellow/AgeIcon.png';

import AnnualRevenueIconGreen from './green/AnnualRevenueIcon.png';
import AnnualRevenueIconBlue from './blue/AnnualRevenueIcon.png';
import AnnualRevenueIconRed from './red/AnnualRevenueIcon.png';
import AnnualRevenueIconBlueGreen from './blueGreen/AnnualRevenueIcon.png';
import AnnualRevenueIconBlueRed from './blueRed/AnnualRevenueIcon.png';
import AnnualRevenueIconBlueYellow from './blueYellow/AnnualRevenueIcon.png';

import AnnualSalesIconGreen from './green/AnnualSalesIcon.png';
import AnnualSalesIconBlue from './blue/AnnualSalesIcon.png';
import AnnualSalesIconRed from './red/AnnualSalesIcon.png';
import AnnualSalesIconBlueGreen from './blueGreen/AnnualSalesIcon.png';
import AnnualSalesIconBlueRed from './blueRed/AnnualSalesIcon.png';
import AnnualSalesIconBlueYellow from './blueYellow/AnnualSalesIcon.png';

import AreaIconGreen from './green/AreaIcon.png';
import AreaIconBlue from './blue/AreaIcon.png';
import AreaIconRed from './red/AreaIcon.png';
import AreaIconBlueGreen from './blueGreen/AreaIcon.png';
import AreaIconBlueRed from './blueRed/AreaIcon.png';
import AreaIconBlueYellow from './blueYellow/AreaIcon.png';

import BriefProductDescriptionIconGreen from './green/BriefProductDescriptionIcon.png';
import BriefProductDescriptionIconBlue from './blue/BriefProductDescriptionIcon.png';
import BriefProductDescriptionIconRed from './red/BriefProductDescriptionIcon.png';
import BriefProductDescriptionIconBlueGreen from './blueGreen/BriefProductDescriptionIcon.png';
import BriefProductDescriptionIconBlueRed from './blueRed/BriefProductDescriptionIcon.png';
import BriefProductDescriptionIconBlueYellow from './blueYellow/BriefProductDescriptionIcon.png';

import ContactPersonIconGreen from './green/ContactPersonIcon.png';
import ContactPersonIconBlue from './blue/ContactPersonIcon.png';
import ContactPersonIconRed from './red/ContactPersonIcon.png';
import ContactPersonIconBlueGreen from './blueGreen/ContactPersonIcon.png';
import ContactPersonIconBlueRed from './blueRed/ContactPersonIcon.png';
import ContactPersonIconBlueYellow from './blueYellow/ContactPersonIcon.png';

import CoverPageAddressIconGreen from './green/CoverPageAddressIcon.png';
import CoverPageAddressIconBlue from './blue/CoverPageAddressIcon.png';
import CoverPageAddressIconRed from './red/CoverPageAddressIcon.png';
import CoverPageAddressIconBlueGreen from './blueGreen/CoverPageAddressIcon.png';
import CoverPageAddressIconBlueRed from './blueRed/CoverPageAddressIcon.png';
import CoverPageAddressIconBlueYellow from './blueYellow/CoverPageAddressIcon.png';

import CoverPageMailIconGreen from './green/CoverPageMailIcon.png';
import CoverPageMailIconBlue from './blue/CoverPageMailIcon.png';
import CoverPageMailIconRed from './red/CoverPageMailIcon.png';
import CoverPageMailIconBlueGreen from './blueGreen/CoverPageMailIcon.png';
import CoverPageMailIconBlueRed from './blueRed/CoverPageMailIcon.png';
import CoverPageMailIconBlueYellow from './blueYellow/CoverPageMailIcon.png';

import CoverPageNameIconGreen from './green/CoverPageNameIcon.png';
import CoverPageNameIconBlue from './blue/CoverPageNameIcon.png';
import CoverPageNameIconRed from './red/CoverPageNameIcon.png';
import CoverPageNameIconBlueGreen from './blueGreen/CoverPageNameIcon.png';
import CoverPageNameIconBlueRed from './blueRed/CoverPageNameIcon.png';
import CoverPageNameIconBlueYellow from './blueYellow/CoverPageNameIcon.png';

import CoverPagePhoneIconGreen from './green/CoverPagePhoneIcon.png';
import CoverPagePhoneIconBlue from './blue/CoverPagePhoneIcon.png';
import CoverPagePhoneIconRed from './red/CoverPagePhoneIcon.png';
import CoverPagePhoneIconBlueGreen from './blueGreen/CoverPagePhoneIcon.png';
import CoverPagePhoneIconBlueRed from './blueRed/CoverPagePhoneIcon.png';
import CoverPagePhoneIconBlueYellow from './blueYellow/CoverPagePhoneIcon.png';

import CoverPageWebsiteIconGreen from './green/CoverPageWebsiteIcon.png';
import CoverPageWebsiteIconBlue from './blue/CoverPageWebsiteIcon.png';
import CoverPageWebsiteIconRed from './red/CoverPageWebsiteIcon.png';
import CoverPageWebsiteIconBlueGreen from './blueGreen/CoverPageWebsiteIcon.png';
import CoverPageWebsiteIconBlueRed from './blueRed/CoverPageWebsiteIcon.png';
import CoverPageWebsiteIconBlueYellow from './blueYellow/CoverPageWebsiteIcon.png';

import CurrentCostIconGreen from './green/CurrentCostIcon.png';
import CurrentCostIconBlue from './blue/CurrentCostIcon.png';
import CurrentCostIconRed from './red/CurrentCostIcon.png';
import CurrentCostIconBlueGreen from './blueGreen/CurrentCostIcon.png';
import CurrentCostIconBlueRed from './blueRed/CurrentCostIcon.png';
import CurrentCostIconBlueYellow from './blueYellow/CurrentCostIcon.png';

import DeliveryTermsIconGreen from './green/DeliveryTermsIcon.png';
import DeliveryTermsIconBlue from './blue/DeliveryTermsIcon.png';
import DeliveryTermsIconRed from './red/DeliveryTermsIcon.png';
import DeliveryTermsIconBlueGreen from './blueGreen/DeliveryTermsIcon.png';
import DeliveryTermsIconBlueRed from './blueRed/DeliveryTermsIcon.png';
import DeliveryTermsIconBlueYellow from './blueYellow/DeliveryTermsIcon.png';

import EmailIconGreen from './green/EmailIcon.png';
import EmailIconBlue from './blue/EmailIcon.png';
import EmailIconRed from './red/EmailIcon.png';
import EmailIconBlueGreen from './blueGreen/EmailIcon.png';
import EmailIconBlueRed from './blueRed/EmailIcon.png';
import EmailIconBlueYellow from './blueYellow/EmailIcon.png';

import FacebookIconGreen from './green/FacebookIcon.png';
import FacebookIconBlue from './blue/FacebookIcon.png';
import FacebookIconRed from './red/FacebookIcon.png';
import FacebookIconBlueGreen from './blueGreen/FacebookIcon.png';
import FacebookIconBlueRed from './blueRed/FacebookIcon.png';
import FacebookIconBlueYellow from './blueYellow/FacebookIcon.png';

import FoundersListIconGreen from './green/FoundersListIcon.png';
import FoundersListIconBlue from './blue/FoundersListIcon.png';
import FoundersListIconRed from './red/FoundersListIcon.png';
import FoundersListIconBlueGreen from './blueGreen/FoundersListIcon.png';
import FoundersListIconBlueRed from './blueRed/FoundersListIcon.png';
import FoundersListIconBlueYellow from './blueYellow/FoundersListIcon.png';

import FundingByOwnFundsIconGreen from './green/FundingByOwnFundsIcon.png';
import FundingByOwnFundsIconBlue from './blue/FundingByOwnFundsIcon.png';
import FundingByOwnFundsIconRed from './red/FundingByOwnFundsIcon.png';
import FundingByOwnFundsIconBlueGreen from './blueGreen/FundingByOwnFundsIcon.png';
import FundingByOwnFundsIconBlueRed from './blueRed/FundingByOwnFundsIcon.png';
import FundingByOwnFundsIconBlueYellow from './blueYellow/FundingByOwnFundsIcon.png';

import FundingDirectionsIconGreen from './green/FundingDirectionsIcon.png';
import FundingDirectionsIconBlue from './blue/FundingDirectionsIcon.png';
import FundingDirectionsIconRed from './red/FundingDirectionsIcon.png';
import FundingDirectionsIconBlueGreen from './blueGreen/FundingDirectionsIcon.png';
import FundingDirectionsIconBlueRed from './blueRed/FundingDirectionsIcon.png';
import FundingDirectionsIconBlueYellow from './blueYellow/FundingDirectionsIcon.png';

import FundingNeedsIconGreen from './green/FundingNeedsIcon.png';
import FundingNeedsIconBlue from './blue/FundingNeedsIcon.png';
import FundingNeedsIconRed from './red/FundingNeedsIcon.png';
import FundingNeedsIconBlueGreen from './blueGreen/FundingNeedsIcon.png';
import FundingNeedsIconBlueRed from './blueRed/FundingNeedsIcon.png';
import FundingNeedsIconBlueYellow from './blueYellow/FundingNeedsIcon.png';

import GenderIconGreen from './green/GenderIcon.png';
import GenderIconBlue from './blue/GenderIcon.png';
import GenderIconRed from './red/GenderIcon.png';
import GenderIconBlueGreen from './blueGreen/GenderIcon.png';
import GenderIconBlueRed from './blueRed/GenderIcon.png';
import GenderIconBlueYellow from './blueYellow/GenderIcon.png';

import IncomeIconGreen from './green/IncomeIcon.png';
import IncomeIconBlue from './blue/IncomeIcon.png';
import IncomeIconRed from './red/IncomeIcon.png';
import IncomeIconBlueGreen from './blueGreen/IncomeIcon.png';
import IncomeIconBlueRed from './blueRed/IncomeIcon.png';
import IncomeIconBlueYellow from './blueYellow/IncomeIcon.png';

import IndustryIconGreen from './green/IndustryIcon.png';
import IndustryIconBlue from './blue/IndustryIcon.png';
import IndustryIconRed from './red/IndustryIcon.png';
import IndustryIconBlueGreen from './blueGreen/IndustryIcon.png';
import IndustryIconBlueRed from './blueRed/IndustryIcon.png';
import IndustryIconBlueYellow from './blueYellow/IndustryIcon.png';

import InstagramIconGreen from './green/InstagramIcon.png';
import InstagramIconBlue from './blue/InstagramIcon.png';
import InstagramIconRed from './red/InstagramIcon.png';
import InstagramIconBlueGreen from './blueGreen/InstagramIcon.png';
import InstagramIconBlueRed from './blueRed/InstagramIcon.png';
import InstagramIconBlueYellow from './blueYellow/InstagramIcon.png';

import InvestmentRaisedIconGreen from './green/InvestmentRaisedIcon.png';
import InvestmentRaisedIconBlue from './blue/InvestmentRaisedIcon.png';
import InvestmentRaisedIconRed from './red/InvestmentRaisedIcon.png';
import InvestmentRaisedIconBlueGreen from './blueGreen/InvestmentRaisedIcon.png';
import InvestmentRaisedIconBlueRed from './blueRed/InvestmentRaisedIcon.png';
import InvestmentRaisedIconBlueYellow from './blueYellow/InvestmentRaisedIcon.png';

import IRRIconGreen from './green/IRRIcon.png';
import IRRIconBlue from './blue/IRRIcon.png';
import IRRIconRed from './red/IRRIcon.png';
import IRRIconBlueGreen from './blueGreen/IRRIcon.png';
import IRRIconBlueRed from './blueRed/IRRIcon.png';
import IRRIconBlueYellow from './blueYellow/IRRIcon.png';

import LegalStructureIconGreen from './green/LegalStructureIcon.png';
import LegalStructureIconBlue from './blue/LegalStructureIcon.png';
import LegalStructureIconRed from './red/LegalStructureIcon.png';
import LegalStructureIconBlueGreen from './blueGreen/LegalStructureIcon.png';
import LegalStructureIconBlueRed from './blueRed/LegalStructureIcon.png';
import LegalStructureIconBlueYellow from './blueYellow/LegalStructureIcon.png';

import LinkedinIconGreen from './green/LinkedinIcon.png';
import LinkedinIconBlue from './blue/LinkedinIcon.png';
import LinkedinIconRed from './red/LinkedinIcon.png';
import LinkedinIconBlueGreen from './blueGreen/LinkedinIcon.png';
import LinkedinIconBlueRed from './blueRed/LinkedinIcon.png';
import LinkedinIconBlueYellow from './blueYellow/LinkedinIcon.png';

import LoanAmountPlannedIconGreen from './green/LoanAmountPlannedIcon.png';
import LoanAmountPlannedIconBlue from './blue/LoanAmountPlannedIcon.png';
import LoanAmountPlannedIconRed from './red/LoanAmountPlannedIcon.png';
import LoanAmountPlannedIconBlueGreen from './blueGreen/LoanAmountPlannedIcon.png';
import LoanAmountPlannedIconBlueRed from './blueRed/LoanAmountPlannedIcon.png';
import LoanAmountPlannedIconBlueYellow from './blueYellow/LoanAmountPlannedIcon.png';

import LogoFourChapterIconGreen from './green/LogoFourChapterIcon.png';
import LogoFourChapterIconBlue from './blue/LogoFourChapterIcon.png';
import LogoFourChapterIconRed from './red/LogoFourChapterIcon.png';
import LogoFourChapterIconBlueGreen from './blueGreen/LogoFourChapterIcon.png';
import LogoFourChapterIconBlueRed from './blueRed/LogoFourChapterIcon.png';
import LogoFourChapterIconBlueYellow from './blueYellow/LogoFourChapterIcon.png';

import MarketShareIconGreen from './green/MarketShareIcon.png';
import MarketShareIconBlue from './blue/MarketShareIcon.png';
import MarketShareIconRed from './red/MarketShareIcon.png';
import MarketShareIconBlueGreen from './blueGreen/MarketShareIcon.png';
import MarketShareIconBlueRed from './blueRed/MarketShareIcon.png';
import MarketShareIconBlueYellow from './blueYellow/MarketShareIcon.png';

import NameChapterFourIconGreen from './green/NameChapterFourIcon.png';
import NameChapterFourIconBlue from './blue/NameChapterFourIcon.png';
import NameChapterFourIconRed from './red/NameChapterFourIcon.png';
import NameChapterFourIconBlueGreen from './blueGreen/NameChapterFourIcon.png';
import NameChapterFourIconBlueRed from './blueRed/NameChapterFourIcon.png';
import NameChapterFourIconBlueYellow from './blueYellow/NameChapterFourIcon.png';

import NameIconGreen from './green/NameIcon.png';
import NameIconBlue from './blue/NameIcon.png';
import NameIconRed from './red/NameIcon.png';
import NameIconBlueGreen from './blueGreen/NameIcon.png';
import NameIconBlueRed from './blueRed/NameIcon.png';
import NameIconBlueYellow from './blueYellow/NameIcon.png';

import NameOfGroupIconGreen from './green/NameOfGroupIcon.png';
import NameOfGroupIconBlue from './blue/NameOfGroupIcon.png';
import NameOfGroupIconRed from './red/NameOfGroupIcon.png';
import NameOfGroupIconBlueGreen from './blueGreen/NameOfGroupIcon.png';
import NameOfGroupIconBlueRed from './blueRed/NameOfGroupIcon.png';
import NameOfGroupIconBlueYellow from './blueYellow/NameOfGroupIcon.png';

import NeedsAndProblemsIconGreen from './green/NeedsAndProblemsIcon.png';
import NeedsAndProblemsIconBlue from './blue/NeedsAndProblemsIcon.png';
import NeedsAndProblemsIconRed from './red/NeedsAndProblemsIcon.png';
import NeedsAndProblemsIconBlueGreen from './blueGreen/NeedsAndProblemsIcon.png';
import NeedsAndProblemsIconBlueRed from './blueRed/NeedsAndProblemsIcon.png';
import NeedsAndProblemsIconBlueYellow from './blueYellow/NeedsAndProblemsIcon.png';

import NumberOfEmployeesFourIconGreen from './green/NumberOfEmployeesFourIcon.png';
import NumberOfEmployeesFourIconBlue from './blue/NumberOfEmployeesFourIcon.png';
import NumberOfEmployeesFourIconRed from './red/NumberOfEmployeesFourIcon.png';
import NumberOfEmployeesFourIconBlueGreen from './blueGreen/NumberOfEmployeesFourIcon.png';
import NumberOfEmployeesFourIconBlueRed from './blueRed/NumberOfEmployeesFourIcon.png';
import NumberOfEmployeesFourIconBlueYellow from './blueYellow/NumberOfEmployeesFourIcon.png';

import NumberOfEmployeesIconGreen from './green/NumberOfEmployeesIcon.png';
import NumberOfEmployeesIconBlue from './blue/NumberOfEmployeesIcon.png';
import NumberOfEmployeesIconRed from './red/NumberOfEmployeesIcon.png';
import NumberOfEmployeesIconBlueGreen from './blueGreen/NumberOfEmployeesIcon.png';
import NumberOfEmployeesIconBlueRed from './blueRed/NumberOfEmployeesIcon.png';
import NumberOfEmployeesIconBlueYellow from './blueYellow/NumberOfEmployeesIcon.png';

import NumberOfItemsIconGreen from './green/NumberOfItemsIcon.png';
import NumberOfItemsIconBlue from './blue/NumberOfItemsIcon.png';
import NumberOfItemsIconRed from './red/NumberOfItemsIcon.png';
import NumberOfItemsIconBlueGreen from './blueGreen/NumberOfItemsIcon.png';
import NumberOfItemsIconBlueRed from './blueRed/NumberOfItemsIcon.png';
import NumberOfItemsIconBlueYellow from './blueYellow/NumberOfItemsIcon.png';

import OperatingIndustryIconGreen from './green/OperatingIndustryIcon.png';
import OperatingIndustryIconBlue from './blue/OperatingIndustryIcon.png';
import OperatingIndustryIconRed from './red/OperatingIndustryIcon.png';
import OperatingIndustryIconBlueGreen from './blueGreen/OperatingIndustryIcon.png';
import OperatingIndustryIconBlueRed from './blueRed/OperatingIndustryIcon.png';
import OperatingIndustryIconBlueYellow from './blueYellow/OperatingIndustryIcon.png';

import OtherSocialNetworksIconGreen from './green/OtherSocialNetworksIcon.png';
import OtherSocialNetworksIconBlue from './blue/OtherSocialNetworksIcon.png';
import OtherSocialNetworksIconRed from './red/OtherSocialNetworksIcon.png';
import OtherSocialNetworksIconBlueGreen from './blueGreen/OtherSocialNetworksIcon.png';
import OtherSocialNetworksIconBlueRed from './blueRed/OtherSocialNetworksIcon.png';
import OtherSocialNetworksIconBlueYellow from './blueYellow/OtherSocialNetworksIcon.png';

import PastAnnualIncomeIconGreen from './green/PastAnnualIncomeIcon.png';
import PastAnnualIncomeIconBlue from './blue/PastAnnualIncomeIcon.png';
import PastAnnualIncomeIconRed from './red/PastAnnualIncomeIcon.png';
import PastAnnualIncomeIconBlueGreen from './blueGreen/PastAnnualIncomeIcon.png';
import PastAnnualIncomeIconBlueRed from './blueRed/PastAnnualIncomeIcon.png';
import PastAnnualIncomeIconBlueYellow from './blueYellow/PastAnnualIncomeIcon.png';

import PastAnnualProfitGreen from './green/PastAnnualProfit.png';
import PastAnnualProfitBlue from './blue/PastAnnualProfit.png';
import PastAnnualProfitRed from './red/PastAnnualProfit.png';
import PastAnnualProfitBlueGreen from './blueGreen/PastAnnualProfit.png';
import PastAnnualProfitBlueRed from './blueRed/PastAnnualProfit.png';
import PastAnnualProfitBlueYellow from './blueYellow/PastAnnualProfit.png';

import PersonalInterestsIconGreen from './green/PersonalInterestsIcon.png';
import PersonalInterestsIconBlue from './blue/PersonalInterestsIcon.png';
import PersonalInterestsIconRed from './red/PersonalInterestsIcon.png';
import PersonalInterestsIconBlueGreen from './blueGreen/PersonalInterestsIcon.png';
import PersonalInterestsIconBlueRed from './blueRed/PersonalInterestsIcon.png';
import PersonalInterestsIconBlueYellow from './blueYellow/PersonalInterestsIcon.png';

import PhoneIconGreen from './green/PhoneIcon.png';
import PhoneIconBlue from './blue/PhoneIcon.png';
import PhoneIconRed from './red/PhoneIcon.png';
import PhoneIconBlueGreen from './blueGreen/PhoneIcon.png';
import PhoneIconBlueRed from './blueRed/PhoneIcon.png';
import PhoneIconBlueYellow from './blueYellow/PhoneIcon.png';

import PhotoIconGreen from './green/PhotoIcon.png';
import PhotoIconBlue from './blue/PhotoIcon.png';
import PhotoIconRed from './red/PhotoIcon.png';
import PhotoIconBlueGreen from './blueGreen/PhotoIcon.png';
import PhotoIconBlueRed from './blueRed/PhotoIcon.png';
import PhotoIconBlueYellow from './blueYellow/PhotoIcon.png';

import PositioningIconGreen from './green/PositioningIcon.png';
import PositioningIconBlue from './blue/PositioningIcon.png';
import PositioningIconRed from './red/PositioningIcon.png';
import PositioningIconBlueGreen from './blueGreen/PositioningIcon.png';
import PositioningIconBlueRed from './blueRed/PositioningIcon.png';
import PositioningIconBlueYellow from './blueYellow/PositioningIcon.png';

import PPPIconGreen from './green/PPPIcon.png';
import PPPIconBlue from './blue/PPPIcon.png';
import PPPIconRed from './red/PPPIcon.png';
import PPPIconBlueGreen from './blueGreen/PPPIcon.png';
import PPPIconBlueRed from './blueRed/PPPIcon.png';
import PPPIconBlueYellow from './blueYellow/PPPIcon.png';

import PriceIconGreen from './green/PriceIcon.png';
import PriceIconBlue from './blue/PriceIcon.png';
import PriceIconRed from './red/PriceIcon.png';
import PriceIconBlueGreen from './blueGreen/PriceIcon.png';
import PriceIconBlueRed from './blueRed/PriceIcon.png';
import PriceIconBlueYellow from './blueYellow/PriceIcon.png';

import PricingPolicyIconGreen from './green/PricingPolicyIcon.png';
import PricingPolicyIconBlue from './blue/PricingPolicyIcon.png';
import PricingPolicyIconRed from './red/PricingPolicyIcon.png';
import PricingPolicyIconBlueGreen from './blueGreen/PricingPolicyIcon.png';
import PricingPolicyIconBlueRed from './blueRed/PricingPolicyIcon.png';
import PricingPolicyIconBlueYellow from './blueYellow/PricingPolicyIcon.png';

import ProfessionIconGreen from './green/ProfessionIcon.png';
import ProfessionIconBlue from './blue/ProfessionIcon.png';
import ProfessionIconRed from './red/ProfessionIcon.png';
import ProfessionIconBlueGreen from './blueGreen/ProfessionIcon.png';
import ProfessionIconBlueRed from './blueRed/ProfessionIcon.png';
import ProfessionIconBlueYellow from './blueYellow/ProfessionIcon.png';

import ProjectedAnnualIncomeIconGreen from './green/ProjectedAnnualIncomeIcon.png';
import ProjectedAnnualIncomeIconBlue from './blue/ProjectedAnnualIncomeIcon.png';
import ProjectedAnnualIncomeIconRed from './red/ProjectedAnnualIncomeIcon.png';
import ProjectedAnnualIncomeIconBlueGreen from './blueGreen/ProjectedAnnualIncomeIcon.png';
import ProjectedAnnualIncomeIconBlueRed from './blueRed/ProjectedAnnualIncomeIcon.png';
import ProjectedAnnualIncomeIconBlueYellow from './blueYellow/ProjectedAnnualIncomeIcon.png';

import ProjectedAnnualProfitIconGreen from './green/ProjectedAnnualProfitIcon.png';
import ProjectedAnnualProfitIconBlue from './blue/ProjectedAnnualProfitIcon.png';
import ProjectedAnnualProfitIconRed from './red/ProjectedAnnualProfitIcon.png';
import ProjectedAnnualProfitIconBlueGreen from './blueGreen/ProjectedAnnualProfitIcon.png';
import ProjectedAnnualProfitIconBlueRed from './blueRed/ProjectedAnnualProfitIcon.png';
import ProjectedAnnualProfitIconBlueYellow from './blueYellow/ProjectedAnnualProfitIcon.png';

import ProjectedProfitabilityIconGreen from './green/ProjectedProfitabilityIcon.png';
import ProjectedProfitabilityIconBlue from './blue/ProjectedProfitabilityIcon.png';
import ProjectedProfitabilityIconRed from './red/ProjectedProfitabilityIcon.png';
import ProjectedProfitabilityIconBlueGreen from './blueGreen/ProjectedProfitabilityIcon.png';
import ProjectedProfitabilityIconBlueRed from './blueRed/ProjectedProfitabilityIcon.png';
import ProjectedProfitabilityIconBlueYellow from './blueYellow/ProjectedProfitabilityIcon.png';

import PurchasingCycleIconGreen from './green/PurchasingCycleIcon.png';
import PurchasingCycleIconBlue from './blue/PurchasingCycleIcon.png';
import PurchasingCycleIconRed from './red/PurchasingCycleIcon.png';
import PurchasingCycleIconBlueGreen from './blueGreen/PurchasingCycleIcon.png';
import PurchasingCycleIconBlueRed from './blueRed/PurchasingCycleIcon.png';
import PurchasingCycleIconBlueYellow from './blueYellow/PurchasingCycleIcon.png';

import PurchasingHabitsIconGreen from './green/PurchasingHabitsIcon.png';
import PurchasingHabitsIconBlue from './blue/PurchasingHabitsIcon.png';
import PurchasingHabitsIconRed from './red/PurchasingHabitsIcon.png';
import PurchasingHabitsIconBlueGreen from './blueGreen/PurchasingHabitsIcon.png';
import PurchasingHabitsIconBlueRed from './blueRed/PurchasingHabitsIcon.png';
import PurchasingHabitsIconBlueYellow from './blueYellow/PurchasingHabitsIcon.png';

import PurposeIconGreen from './green/PurposeIcon.png';
import PurposeIconBlue from './blue/PurposeIcon.png';
import PurposeIconRed from './red/PurposeIcon.png';
import PurposeIconBlueGreen from './blueGreen/PurposeIcon.png';
import PurposeIconBlueRed from './blueRed/PurposeIcon.png';
import PurposeIconBlueYellow from './blueYellow/PurposeIcon.png';

import QuantityPerMonthIconGreen from './green/QuantityPerMonthIcon.png';
import QuantityPerMonthIconBlue from './blue/QuantityPerMonthIcon.png';
import QuantityPerMonthIconRed from './red/QuantityPerMonthIcon.png';
import QuantityPerMonthIconBlueGreen from './blueGreen/QuantityPerMonthIcon.png';
import QuantityPerMonthIconBlueRed from './blueRed/QuantityPerMonthIcon.png';
import QuantityPerMonthIconBlueYellow from './blueYellow/QuantityPerMonthIcon.png';

import RegistrationDateIconGreen from './green/RegistrationDateIcon.png';
import RegistrationDateIconBlue from './blue/RegistrationDateIcon.png';
import RegistrationDateIconRed from './red/RegistrationDateIcon.png';
import RegistrationDateIconBlueGreen from './blueGreen/RegistrationDateIcon.png';
import RegistrationDateIconBlueRed from './blueRed/RegistrationDateIcon.png';
import RegistrationDateIconBlueYellow from './blueYellow/RegistrationDateIcon.png';

import ROIIconGreen from './green/ROIIcon.png';
import ROIIconBlue from './blue/ROIIcon.png';
import ROIIconRed from './red/ROIIcon.png';
import ROIIconBlueGreen from './blueGreen/ROIIcon.png';
import ROIIconBlueRed from './blueRed/ROIIcon.png';
import ROIIconBlueYellow from './blueYellow/ROIIcon.png';

import SalesChannelsIconGreen from './green/SalesChannelsIcon.png';
import SalesChannelsIconBlue from './blue/SalesChannelsIcon.png';
import SalesChannelsIconRed from './red/SalesChannelsIcon.png';
import SalesChannelsIconBlueGreen from './blueGreen/SalesChannelsIcon.png';
import SalesChannelsIconBlueRed from './blueRed/SalesChannelsIcon.png';
import SalesChannelsIconBlueYellow from './blueYellow/SalesChannelsIcon.png';

import ServiceProductIconGreen from './green/ServiceProductIcon.png';
import ServiceProductIconBlue from './blue/ServiceProductIcon.png';
import ServiceProductIconRed from './red/ServiceProductIcon.png';
import ServiceProductIconBlueGreen from './blueGreen/ServiceProductIcon.png';
import ServiceProductIconBlueRed from './blueRed/ServiceProductIcon.png';
import ServiceProductIconBlueYellow from './blueYellow/ServiceProductIcon.png';

import SizeOfYourAssetsIconGreen from './green/SizeOfYourAssetsIcon.png';
import SizeOfYourAssetsIconBlue from './blue/SizeOfYourAssetsIcon.png';
import SizeOfYourAssetsIconRed from './red/SizeOfYourAssetsIcon.png';
import SizeOfYourAssetsIconBlueGreen from './blueGreen/SizeOfYourAssetsIcon.png';
import SizeOfYourAssetsIconBlueRed from './blueRed/SizeOfYourAssetsIcon.png';
import SizeOfYourAssetsIconBlueYellow from './blueYellow/SizeOfYourAssetsIcon.png';

import SocialNetworksIconGreen from './green/SocialNetworksIcon.png';
import SocialNetworksIconBlue from './blue/SocialNetworksIcon.png';
import SocialNetworksIconRed from './red/SocialNetworksIcon.png';
import SocialNetworksIconBlueGreen from './blueGreen/SocialNetworksIcon.png';
import SocialNetworksIconBlueRed from './blueRed/SocialNetworksIcon.png';
import SocialNetworksIconBlueYellow from './blueYellow/SocialNetworksIcon.png';

import StrengthFourIconGreen from './green/StrengthFourIcon.png';
import StrengthFourIconBlue from './blue/StrengthFourIcon.png';
import StrengthFourIconRed from './red/StrengthFourIcon.png';
import StrengthFourIconBlueGreen from './blueGreen/StrengthFourIcon.png';
import StrengthFourIconBlueRed from './blueRed/StrengthFourIcon.png';
import StrengthFourIconBlueYellow from './blueYellow/StrengthFourIcon.png';

import SupplierNameIconGreen from './green/SupplierNameIcon.png';
import SupplierNameIconBlue from './blue/SupplierNameIcon.png';
import SupplierNameIconRed from './red/SupplierNameIcon.png';
import SupplierNameIconBlueGreen from './blueGreen/SupplierNameIcon.png';
import SupplierNameIconBlueRed from './blueRed/SupplierNameIcon.png';
import SupplierNameIconBlueYellow from './blueYellow/SupplierNameIcon.png';

import TermsOfUseIconGreen from './green/TermsOfUseIcon.png';
import TermsOfUseIconBlue from './blue/TermsOfUseIcon.png';
import TermsOfUseIconRed from './red/TermsOfUseIcon.png';
import TermsOfUseIconBlueGreen from './blueGreen/TermsOfUseIcon.png';
import TermsOfUseIconBlueRed from './blueRed/TermsOfUseIcon.png';
import TermsOfUseIconBlueYellow from './blueYellow/TermsOfUseIcon.png';

import WeaknessFourIconGreen from './green/WeaknessFourIcon.png';
import WeaknessFourIconBlue from './blue/WeaknessFourIcon.png';
import WeaknessFourIconRed from './red/WeaknessFourIcon.png';
import WeaknessFourIconBlueGreen from './blueGreen/WeaknessFourIcon.png';
import WeaknessFourIconBlueRed from './blueRed/WeaknessFourIcon.png';
import WeaknessFourIconBlueYellow from './blueYellow/WeaknessFourIcon.png';

import WebsiteChapterFourIconGreen from './green/WebsiteChapterFourIcon.png';
import WebsiteChapterFourIconBlue from './blue/WebsiteChapterFourIcon.png';
import WebsiteChapterFourIconRed from './red/WebsiteChapterFourIcon.png';
import WebsiteChapterFourIconBlueGreen from './blueGreen/WebsiteChapterFourIcon.png';
import WebsiteChapterFourIconBlueRed from './blueRed/WebsiteChapterFourIcon.png';
import WebsiteChapterFourIconBlueYellow from './blueYellow/WebsiteChapterFourIcon.png';

import WebsiteIconGreen from './green/WebsiteIcon.png';
import WebsiteIconBlue from './blue/WebsiteIcon.png';
import WebsiteIconRed from './red/WebsiteIcon.png';
import WebsiteIconBlueGreen from './blueGreen/WebsiteIcon.png';
import WebsiteIconBlueRed from './blueRed/WebsiteIcon.png';
import WebsiteIconBlueYellow from './blueYellow/WebsiteIcon.png';

export const icons = {
  green: {
    AddressOfRegistrationIcon: AddressOfRegistrationIconGreen,
    AddressTableIcon: AddressTableIconGreen,
    AdressSixIcon: AdressSixIconGreen,
    AgeIcon: AgeIconGreen,
    AnnualRevenueIcon: AnnualRevenueIconGreen,
    AnnualSalesIcon: AnnualSalesIconGreen,
    AreaIcon: AreaIconGreen,
    BriefProductDescriptionIcon: BriefProductDescriptionIconGreen,
    ContactPersonIcon: ContactPersonIconGreen,
    CoverPageAddressIcon: CoverPageAddressIconGreen,
    CoverPageMailIcon: CoverPageMailIconGreen,
    CoverPageNameIcon: CoverPageNameIconGreen,
    CoverPagePhoneIcon: CoverPagePhoneIconGreen,
    CoverPageWebsiteIcon: CoverPageWebsiteIconGreen,
    CurrentCostIcon: CurrentCostIconGreen,
    DeliveryTermsIcon: DeliveryTermsIconGreen,
    EmailIcon: EmailIconGreen,
    FacebookIcon: FacebookIconGreen,
    FoundersListIcon: FoundersListIconGreen,
    FundingByOwnFundsIcon: FundingByOwnFundsIconGreen,
    FundingDirectionsIcon: FundingDirectionsIconGreen,
    FundingNeedsIcon: FundingNeedsIconGreen,
    GenderIcon: GenderIconGreen,
    IncomeIcon: IncomeIconGreen,
    IndustryIcon: GenderIconGreen,
    InstagramIcon: InstagramIconGreen,
    InvestmentRaisedIcon: InvestmentRaisedIconGreen,
    IRRIcon: IRRIconGreen,
    LegalStructureIcon: LegalStructureIconGreen,
    LinkedinIcon: LinkedinIconGreen,
    LoanAmountPlannedIcon: LoanAmountPlannedIconGreen,
    LogoFourChapterIcon: LogoFourChapterIconGreen,
    MarketShareIcon: MarketShareIconGreen,
    NameChapterFourIcon: NameChapterFourIconGreen,
    NameIcon: NameIconGreen,
    NameOfGroupIcon: NameOfGroupIconGreen,
    NeedsAndProblemsIcon: NeedsAndProblemsIconGreen,
    NumberOfEmployeesFourIcon: NumberOfEmployeesFourIconGreen,
    NumberOfEmployeesIcon: NumberOfEmployeesIconGreen,
    NumberOfItemsIcon: NumberOfItemsIconGreen,
    OperatingIndustryIcon: OperatingIndustryIconGreen,
    OtherSocialNetworksIcon: OtherSocialNetworksIconGreen,
    PastAnnualIncomeIcon: PastAnnualIncomeIconGreen,
    PastAnnualProfit: PastAnnualProfitGreen,
    PersonalInterestsIcon: PersonalInterestsIconGreen,
    PhoneIcon: PhoneIconGreen,
    PhotoIcon: PhotoIconGreen,
    PositioningIcon: PositioningIconGreen,
    PPPIcon: PPPIconGreen,
    PriceIcon: PriceIconGreen,
    PricingPolicyIcon: PricingPolicyIconGreen,
    ProfessionIcon: ProfessionIconGreen,
    ProjectedAnnualIncomeIcon: ProjectedAnnualIncomeIconGreen,
    ProjectedAnnualProfitIcon: ProjectedAnnualProfitIconGreen,
    ProjectedProfitabilityIcon: ProjectedProfitabilityIconGreen,
    PurchasingCycleIcon: PurchasingCycleIconGreen,
    PurchasingHabitsIcon: PurchasingHabitsIconGreen,
    PurposeIcon: PurposeIconGreen,
    QuantityPerMonthIcon: QuantityPerMonthIconGreen,
    RegistrationDateIcon: RegistrationDateIconGreen,
    ROIIcon: ROIIconGreen,
    SalesChannelsIcon: SalesChannelsIconGreen,
    ServiceProductIcon: ServiceProductIconGreen,
    SizeOfYourAssetsIcon: SizeOfYourAssetsIconGreen,
    SocialNetworksIcon: SocialNetworksIconGreen,
    StrengthFourIcon: StrengthFourIconGreen,
    SupplierNameIcon: SupplierNameIconGreen,
    TermsOfUseIcon: TermsOfUseIconGreen,
    WeaknessFourIcon: WeaknessFourIconGreen,
    WebsiteChapterFourIcon: WebsiteChapterFourIconGreen,
    WebsiteIcon: WebsiteIconGreen,
  },
  blue: {
    AddressOfRegistrationIcon: AddressOfRegistrationIconBlue,
    AddressTableIcon: AddressTableIconBlue,
    AdressSixIcon: AdressSixIconBlue,
    AgeIcon: AgeIconBlue,
    AnnualRevenueIcon: AnnualRevenueIconBlue,
    AnnualSalesIcon: AnnualSalesIconBlue,
    AreaIcon: AreaIconBlue,
    BriefProductDescriptionIcon: BriefProductDescriptionIconBlue,
    ContactPersonIcon: ContactPersonIconBlue,
    CoverPageAddressIcon: CoverPageAddressIconBlue,
    CoverPageMailIcon: CoverPageMailIconBlue,
    CoverPageNameIcon: CoverPageNameIconBlue,
    CoverPagePhoneIcon: CoverPagePhoneIconBlue,
    CoverPageWebsiteIcon: CoverPageWebsiteIconBlue,
    CurrentCostIcon: CurrentCostIconBlue,
    DeliveryTermsIcon: DeliveryTermsIconBlue,
    EmailIcon: EmailIconBlue,
    FacebookIcon: FacebookIconBlue,
    FoundersListIcon: FoundersListIconBlue,
    FundingByOwnFundsIcon: FundingByOwnFundsIconBlue,
    FundingDirectionsIcon: FundingDirectionsIconBlue,
    FundingNeedsIcon: FundingNeedsIconBlue,
    GenderIcon: GenderIconBlue,
    IncomeIcon: IncomeIconBlue,
    IndustryIcon: GenderIconBlue,
    InstagramIcon: InstagramIconBlue,
    InvestmentRaisedIcon: InvestmentRaisedIconBlue,
    IRRIcon: IRRIconBlue,
    LegalStructureIcon: LegalStructureIconBlue,
    LinkedinIcon: LinkedinIconBlue,
    LoanAmountPlannedIcon: LoanAmountPlannedIconBlue,
    LogoFourChapterIcon: LogoFourChapterIconBlue,
    MarketShareIcon: MarketShareIconBlue,
    NameChapterFourIcon: NameChapterFourIconBlue,
    NameIcon: NameIconBlue,
    NameOfGroupIcon: NameOfGroupIconBlue,
    NeedsAndProblemsIcon: NeedsAndProblemsIconBlue,
    NumberOfEmployeesFourIcon: NumberOfEmployeesFourIconBlue,
    NumberOfEmployeesIcon: NumberOfEmployeesIconBlue,
    NumberOfItemsIcon: NumberOfItemsIconBlue,
    OperatingIndustryIcon: OperatingIndustryIconBlue,
    OtherSocialNetworksIcon: OtherSocialNetworksIconBlue,
    PastAnnualIncomeIcon: PastAnnualIncomeIconBlue,
    PastAnnualProfit: PastAnnualProfitBlue,
    PersonalInterestsIcon: PersonalInterestsIconBlue,
    PhoneIcon: PhoneIconBlue,
    PhotoIcon: PhotoIconBlue,
    PositioningIcon: PositioningIconBlue,
    PPPIcon: PPPIconBlue,
    PriceIcon: PriceIconBlue,
    PricingPolicyIcon: PricingPolicyIconBlue,
    ProfessionIcon: ProfessionIconBlue,
    ProjectedAnnualIncomeIcon: ProjectedAnnualIncomeIconBlue,
    ProjectedAnnualProfitIcon: ProjectedAnnualProfitIconBlue,
    ProjectedProfitabilityIcon: ProjectedProfitabilityIconBlue,
    PurchasingCycleIcon: PurchasingCycleIconBlue,
    PurchasingHabitsIcon: PurchasingHabitsIconBlue,
    PurposeIcon: PurposeIconBlue,
    QuantityPerMonthIcon: QuantityPerMonthIconBlue,
    RegistrationDateIcon: RegistrationDateIconBlue,
    ROIIcon: ROIIconBlue,
    SalesChannelsIcon: SalesChannelsIconBlue,
    ServiceProductIcon: ServiceProductIconBlue,
    SizeOfYourAssetsIcon: SizeOfYourAssetsIconBlue,
    SocialNetworksIcon: SocialNetworksIconBlue,
    StrengthFourIcon: StrengthFourIconBlue,
    SupplierNameIcon: SupplierNameIconBlue,
    TermsOfUseIcon: TermsOfUseIconBlue,
    WeaknessFourIcon: WeaknessFourIconBlue,
    WebsiteChapterFourIcon: WebsiteChapterFourIconBlue,
    WebsiteIcon: WebsiteIconBlue,
  },
  red: {
    AddressOfRegistrationIcon: AddressOfRegistrationIconRed,
    AddressTableIcon: AddressTableIconRed,
    AdressSixIcon: AdressSixIconRed,
    AgeIcon: AgeIconRed,
    AnnualRevenueIcon: AnnualRevenueIconRed,
    AnnualSalesIcon: AnnualSalesIconRed,
    AreaIcon: AreaIconRed,
    BriefProductDescriptionIcon: BriefProductDescriptionIconRed,
    ContactPersonIcon: ContactPersonIconRed,
    CoverPageAddressIcon: CoverPageAddressIconRed,
    CoverPageMailIcon: CoverPageMailIconRed,
    CoverPageNameIcon: CoverPageNameIconRed,
    CoverPagePhoneIcon: CoverPagePhoneIconRed,
    CoverPageWebsiteIcon: CoverPageWebsiteIconRed,
    CurrentCostIcon: CurrentCostIconRed,
    DeliveryTermsIcon: DeliveryTermsIconRed,
    EmailIcon: EmailIconRed,
    FacebookIcon: FacebookIconRed,
    FoundersListIcon: FoundersListIconRed,
    FundingByOwnFundsIcon: FundingByOwnFundsIconRed,
    FundingDirectionsIcon: FundingDirectionsIconRed,
    FundingNeedsIcon: FundingNeedsIconRed,
    GenderIcon: GenderIconRed,
    IncomeIcon: IncomeIconRed,
    IndustryIcon: GenderIconRed,
    InstagramIcon: InstagramIconRed,
    InvestmentRaisedIcon: InvestmentRaisedIconRed,
    IRRIcon: IRRIconRed,
    LegalStructureIcon: LegalStructureIconRed,
    LinkedinIcon: LinkedinIconRed,
    LoanAmountPlannedIcon: LoanAmountPlannedIconRed,
    LogoFourChapterIcon: LogoFourChapterIconRed,
    MarketShareIcon: MarketShareIconRed,
    NameChapterFourIcon: NameChapterFourIconRed,
    NameIcon: NameIconRed,
    NameOfGroupIcon: NameOfGroupIconRed,
    NeedsAndProblemsIcon: NeedsAndProblemsIconRed,
    NumberOfEmployeesFourIcon: NumberOfEmployeesFourIconRed,
    NumberOfEmployeesIcon: NumberOfEmployeesIconRed,
    NumberOfItemsIcon: NumberOfItemsIconRed,
    OperatingIndustryIcon: OperatingIndustryIconRed,
    OtherSocialNetworksIcon: OtherSocialNetworksIconRed,
    PastAnnualIncomeIcon: PastAnnualIncomeIconRed,
    PastAnnualProfit: PastAnnualProfitRed,
    PersonalInterestsIcon: PersonalInterestsIconRed,
    PhoneIcon: PhoneIconRed,
    PhotoIcon: PhotoIconRed,
    PositioningIcon: PositioningIconRed,
    PPPIcon: PPPIconRed,
    PriceIcon: PriceIconRed,
    PricingPolicyIcon: PricingPolicyIconRed,
    ProfessionIcon: ProfessionIconRed,
    ProjectedAnnualIncomeIcon: ProjectedAnnualIncomeIconRed,
    ProjectedAnnualProfitIcon: ProjectedAnnualProfitIconRed,
    ProjectedProfitabilityIcon: ProjectedProfitabilityIconRed,
    PurchasingCycleIcon: PurchasingCycleIconRed,
    PurchasingHabitsIcon: PurchasingHabitsIconRed,
    PurposeIcon: PurposeIconRed,
    QuantityPerMonthIcon: QuantityPerMonthIconRed,
    RegistrationDateIcon: RegistrationDateIconRed,
    ROIIcon: ROIIconRed,
    SalesChannelsIcon: SalesChannelsIconRed,
    ServiceProductIcon: ServiceProductIconRed,
    SizeOfYourAssetsIcon: SizeOfYourAssetsIconRed,
    SocialNetworksIcon: SocialNetworksIconRed,
    StrengthFourIcon: StrengthFourIconRed,
    SupplierNameIcon: SupplierNameIconRed,
    TermsOfUseIcon: TermsOfUseIconRed,
    WeaknessFourIcon: WeaknessFourIconRed,
    WebsiteChapterFourIcon: WebsiteChapterFourIconRed,
    WebsiteIcon: WebsiteIconRed,
  },
  blueGreen: {
    AddressOfRegistrationIcon: AddressOfRegistrationIconBlueGreen,
    AddressTableIcon: AddressTableIconBlueGreen,
    AdressSixIcon: AdressSixIconBlueGreen,
    AgeIcon: AgeIconBlueGreen,
    AnnualRevenueIcon: AnnualRevenueIconBlueGreen,
    AnnualSalesIcon: AnnualSalesIconBlueGreen,
    AreaIcon: AreaIconBlueGreen,
    BriefProductDescriptionIcon: BriefProductDescriptionIconBlueGreen,
    ContactPersonIcon: ContactPersonIconBlueGreen,
    CoverPageAddressIcon: CoverPageAddressIconBlueGreen,
    CoverPageMailIcon: CoverPageMailIconBlueGreen,
    CoverPageNameIcon: CoverPageNameIconBlueGreen,
    CoverPagePhoneIcon: CoverPagePhoneIconBlueGreen,
    CoverPageWebsiteIcon: CoverPageWebsiteIconBlueGreen,
    CurrentCostIcon: CurrentCostIconBlueGreen,
    DeliveryTermsIcon: DeliveryTermsIconBlueGreen,
    EmailIcon: EmailIconBlueGreen,
    FacebookIcon: FacebookIconBlueGreen,
    FoundersListIcon: FoundersListIconBlueGreen,
    FundingByOwnFundsIcon: FundingByOwnFundsIconBlueGreen,
    FundingDirectionsIcon: FundingDirectionsIconBlueGreen,
    FundingNeedsIcon: FundingNeedsIconBlueGreen,
    GenderIcon: GenderIconBlueGreen,
    IncomeIcon: IncomeIconBlueGreen,
    IndustryIcon: GenderIconBlueGreen,
    InstagramIcon: InstagramIconBlueGreen,
    InvestmentRaisedIcon: InvestmentRaisedIconBlueGreen,
    IRRIcon: IRRIconBlueGreen,
    LegalStructureIcon: LegalStructureIconBlueGreen,
    LinkedinIcon: LinkedinIconBlueGreen,
    LoanAmountPlannedIcon: LoanAmountPlannedIconBlueGreen,
    LogoFourChapterIcon: LogoFourChapterIconBlueGreen,
    MarketShareIcon: MarketShareIconBlueGreen,
    NameChapterFourIcon: NameChapterFourIconBlueGreen,
    NameIcon: NameIconBlueGreen,
    NameOfGroupIcon: NameOfGroupIconBlueGreen,
    NeedsAndProblemsIcon: NeedsAndProblemsIconBlueGreen,
    NumberOfEmployeesFourIcon: NumberOfEmployeesFourIconBlueGreen,
    NumberOfEmployeesIcon: NumberOfEmployeesIconBlueGreen,
    NumberOfItemsIcon: NumberOfItemsIconBlueGreen,
    OperatingIndustryIcon: OperatingIndustryIconBlueGreen,
    OtherSocialNetworksIcon: OtherSocialNetworksIconBlueGreen,
    PastAnnualIncomeIcon: PastAnnualIncomeIconBlueGreen,
    PastAnnualProfit: PastAnnualProfitBlueGreen,
    PersonalInterestsIcon: PersonalInterestsIconBlueGreen,
    PhoneIcon: PhoneIconBlueGreen,
    PhotoIcon: PhotoIconBlueGreen,
    PositioningIcon: PositioningIconBlueGreen,
    PPPIcon: PPPIconBlueGreen,
    PriceIcon: PriceIconBlueGreen,
    PricingPolicyIcon: PricingPolicyIconBlueGreen,
    ProfessionIcon: ProfessionIconBlueGreen,
    ProjectedAnnualIncomeIcon: ProjectedAnnualIncomeIconBlueGreen,
    ProjectedAnnualProfitIcon: ProjectedAnnualProfitIconBlueGreen,
    ProjectedProfitabilityIcon: ProjectedProfitabilityIconBlueGreen,
    PurchasingCycleIcon: PurchasingCycleIconBlueGreen,
    PurchasingHabitsIcon: PurchasingHabitsIconBlueGreen,
    PurposeIcon: PurposeIconBlueGreen,
    QuantityPerMonthIcon: QuantityPerMonthIconBlueGreen,
    RegistrationDateIcon: RegistrationDateIconBlueGreen,
    ROIIcon: ROIIconBlueGreen,
    SalesChannelsIcon: SalesChannelsIconBlueGreen,
    ServiceProductIcon: ServiceProductIconBlueGreen,
    SizeOfYourAssetsIcon: SizeOfYourAssetsIconBlueGreen,
    SocialNetworksIcon: SocialNetworksIconBlueGreen,
    StrengthFourIcon: StrengthFourIconBlueGreen,
    SupplierNameIcon: SupplierNameIconBlueGreen,
    TermsOfUseIcon: TermsOfUseIconBlueGreen,
    WeaknessFourIcon: WeaknessFourIconBlueGreen,
    WebsiteChapterFourIcon: WebsiteChapterFourIconBlueGreen,
    WebsiteIcon: WebsiteIconBlueGreen,
  },
  blueRed: {
    AddressOfRegistrationIcon: AddressOfRegistrationIconBlueRed,
    AddressTableIcon: AddressTableIconBlueRed,
    AdressSixIcon: AdressSixIconBlueRed,
    AgeIcon: AgeIconBlueRed,
    AnnualRevenueIcon: AnnualRevenueIconBlueRed,
    AnnualSalesIcon: AnnualSalesIconBlueRed,
    AreaIcon: AreaIconBlueRed,
    BriefProductDescriptionIcon: BriefProductDescriptionIconBlueRed,
    ContactPersonIcon: ContactPersonIconBlueRed,
    CoverPageAddressIcon: CoverPageAddressIconBlueRed,
    CoverPageMailIcon: CoverPageMailIconBlueRed,
    CoverPageNameIcon: CoverPageNameIconBlueRed,
    CoverPagePhoneIcon: CoverPagePhoneIconBlueRed,
    CoverPageWebsiteIcon: CoverPageWebsiteIconBlueRed,
    CurrentCostIcon: CurrentCostIconBlueRed,
    DeliveryTermsIcon: DeliveryTermsIconBlueRed,
    EmailIcon: EmailIconBlueRed,
    FacebookIcon: FacebookIconBlueRed,
    FoundersListIcon: FoundersListIconBlueRed,
    FundingByOwnFundsIcon: FundingByOwnFundsIconBlueRed,
    FundingDirectionsIcon: FundingDirectionsIconBlueRed,
    FundingNeedsIcon: FundingNeedsIconBlueRed,
    GenderIcon: GenderIconBlueRed,
    IncomeIcon: IncomeIconBlueRed,
    IndustryIcon: GenderIconBlueRed,
    InstagramIcon: InstagramIconBlueRed,
    InvestmentRaisedIcon: InvestmentRaisedIconBlueRed,
    IRRIcon: IRRIconBlueRed,
    LegalStructureIcon: LegalStructureIconBlueRed,
    LinkedinIcon: LinkedinIconBlueRed,
    LoanAmountPlannedIcon: LoanAmountPlannedIconBlueRed,
    LogoFourChapterIcon: LogoFourChapterIconBlueRed,
    MarketShareIcon: MarketShareIconBlueRed,
    NameChapterFourIcon: NameChapterFourIconBlueRed,
    NameIcon: NameIconBlueRed,
    NameOfGroupIcon: NameOfGroupIconBlueRed,
    NeedsAndProblemsIcon: NeedsAndProblemsIconBlueRed,
    NumberOfEmployeesFourIcon: NumberOfEmployeesFourIconBlueRed,
    NumberOfEmployeesIcon: NumberOfEmployeesIconBlueRed,
    NumberOfItemsIcon: NumberOfItemsIconBlueRed,
    OperatingIndustryIcon: OperatingIndustryIconBlueRed,
    OtherSocialNetworksIcon: OtherSocialNetworksIconBlueRed,
    PastAnnualIncomeIcon: PastAnnualIncomeIconBlueRed,
    PastAnnualProfit: PastAnnualProfitBlueRed,
    PersonalInterestsIcon: PersonalInterestsIconBlueRed,
    PhoneIcon: PhoneIconBlueRed,
    PhotoIcon: PhotoIconBlueRed,
    PositioningIcon: PositioningIconBlueRed,
    PPPIcon: PPPIconBlueRed,
    PriceIcon: PriceIconBlueRed,
    PricingPolicyIcon: PricingPolicyIconBlueRed,
    ProfessionIcon: ProfessionIconBlueRed,
    ProjectedAnnualIncomeIcon: ProjectedAnnualIncomeIconBlueRed,
    ProjectedAnnualProfitIcon: ProjectedAnnualProfitIconBlueRed,
    ProjectedProfitabilityIcon: ProjectedProfitabilityIconBlueRed,
    PurchasingCycleIcon: PurchasingCycleIconBlueRed,
    PurchasingHabitsIcon: PurchasingHabitsIconBlueRed,
    PurposeIcon: PurposeIconBlueRed,
    QuantityPerMonthIcon: QuantityPerMonthIconBlueRed,
    RegistrationDateIcon: RegistrationDateIconBlueRed,
    ROIIcon: ROIIconBlueRed,
    SalesChannelsIcon: SalesChannelsIconBlueRed,
    ServiceProductIcon: ServiceProductIconBlueRed,
    SizeOfYourAssetsIcon: SizeOfYourAssetsIconBlueRed,
    SocialNetworksIcon: SocialNetworksIconBlueRed,
    StrengthFourIcon: StrengthFourIconBlueRed,
    SupplierNameIcon: SupplierNameIconBlueRed,
    TermsOfUseIcon: TermsOfUseIconBlueRed,
    WeaknessFourIcon: WeaknessFourIconBlueRed,
    WebsiteChapterFourIcon: WebsiteChapterFourIconBlueRed,
    WebsiteIcon: WebsiteIconBlueRed,
  },
  blueYellow: {
    AddressOfRegistrationIcon: AddressOfRegistrationIconBlueYellow,
    AddressTableIcon: AddressTableIconBlueYellow,
    AdressSixIcon: AdressSixIconBlueYellow,
    AgeIcon: AgeIconBlueYellow,
    AnnualRevenueIcon: AnnualRevenueIconBlueYellow,
    AnnualSalesIcon: AnnualSalesIconBlueYellow,
    AreaIcon: AreaIconBlueYellow,
    BriefProductDescriptionIcon: BriefProductDescriptionIconBlueYellow,
    ContactPersonIcon: ContactPersonIconBlueYellow,
    CoverPageAddressIcon: CoverPageAddressIconBlueYellow,
    CoverPageMailIcon: CoverPageMailIconBlueYellow,
    CoverPageNameIcon: CoverPageNameIconBlueYellow,
    CoverPagePhoneIcon: CoverPagePhoneIconBlueYellow,
    CoverPageWebsiteIcon: CoverPageWebsiteIconBlueYellow,
    CurrentCostIcon: CurrentCostIconBlueYellow,
    DeliveryTermsIcon: DeliveryTermsIconBlueYellow,
    EmailIcon: EmailIconBlueYellow,
    FacebookIcon: FacebookIconBlueYellow,
    FoundersListIcon: FoundersListIconBlueYellow,
    FundingByOwnFundsIcon: FundingByOwnFundsIconBlueYellow,
    FundingDirectionsIcon: FundingDirectionsIconBlueYellow,
    FundingNeedsIcon: FundingNeedsIconBlueYellow,
    GenderIcon: GenderIconBlueYellow,
    IncomeIcon: IncomeIconBlueYellow,
    IndustryIcon: GenderIconBlueYellow,
    InstagramIcon: InstagramIconBlueYellow,
    InvestmentRaisedIcon: InvestmentRaisedIconBlueYellow,
    IRRIcon: IRRIconBlueYellow,
    LegalStructureIcon: LegalStructureIconBlueYellow,
    LinkedinIcon: LinkedinIconBlueYellow,
    LoanAmountPlannedIcon: LoanAmountPlannedIconBlueYellow,
    LogoFourChapterIcon: LogoFourChapterIconBlueYellow,
    MarketShareIcon: MarketShareIconBlueYellow,
    NameChapterFourIcon: NameChapterFourIconBlueYellow,
    NameIcon: NameIconBlueYellow,
    NameOfGroupIcon: NameOfGroupIconBlueYellow,
    NeedsAndProblemsIcon: NeedsAndProblemsIconBlueYellow,
    NumberOfEmployeesFourIcon: NumberOfEmployeesFourIconBlueYellow,
    NumberOfEmployeesIcon: NumberOfEmployeesIconBlueYellow,
    NumberOfItemsIcon: NumberOfItemsIconBlueYellow,
    OperatingIndustryIcon: OperatingIndustryIconBlueYellow,
    OtherSocialNetworksIcon: OtherSocialNetworksIconBlueYellow,
    PastAnnualIncomeIcon: PastAnnualIncomeIconBlueYellow,
    PastAnnualProfit: PastAnnualProfitBlueYellow,
    PersonalInterestsIcon: PersonalInterestsIconBlueYellow,
    PhoneIcon: PhoneIconBlueYellow,
    PhotoIcon: PhotoIconBlueYellow,
    PositioningIcon: PositioningIconBlueYellow,
    PPPIcon: PPPIconBlueYellow,
    PriceIcon: PriceIconBlueYellow,
    PricingPolicyIcon: PricingPolicyIconBlueYellow,
    ProfessionIcon: ProfessionIconBlueYellow,
    ProjectedAnnualIncomeIcon: ProjectedAnnualIncomeIconBlueYellow,
    ProjectedAnnualProfitIcon: ProjectedAnnualProfitIconBlueYellow,
    ProjectedProfitabilityIcon: ProjectedProfitabilityIconBlueYellow,
    PurchasingCycleIcon: PurchasingCycleIconBlueYellow,
    PurchasingHabitsIcon: PurchasingHabitsIconBlueYellow,
    PurposeIcon: PurposeIconBlueYellow,
    QuantityPerMonthIcon: QuantityPerMonthIconBlueYellow,
    RegistrationDateIcon: RegistrationDateIconBlueYellow,
    ROIIcon: ROIIconBlueYellow,
    SalesChannelsIcon: SalesChannelsIconBlueYellow,
    ServiceProductIcon: ServiceProductIconBlueYellow,
    SizeOfYourAssetsIcon: SizeOfYourAssetsIconBlueYellow,
    SocialNetworksIcon: SocialNetworksIconBlueYellow,
    StrengthFourIcon: StrengthFourIconBlueYellow,
    SupplierNameIcon: SupplierNameIconBlueYellow,
    TermsOfUseIcon: TermsOfUseIconBlueYellow,
    WeaknessFourIcon: WeaknessFourIconBlueYellow,
    WebsiteChapterFourIcon: WebsiteChapterFourIconBlueYellow,
    WebsiteIcon: WebsiteIconBlueYellow,
  },
};
